import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const connectedCasePermissions = (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const connectedCaseId = uiEngineProps.primaryKey.value;
  const permissions = (caseState.stateForCaseIds && caseState.stateForCaseIds[connectedCaseId])
    ? caseState.stateForCaseIds[connectedCaseId].permissions
    : undefined;

  return {
    permissions
  };
};
